
import { defineComponent, PropType, ref } from "vue";
import { useI18n } from "vue-i18n";
import { PostCodeProduct } from "@/models/PostCodeProduct";
import { DeliveryMethodApi } from "@/services/Api";

export default defineComponent({
    props: {
        postcodeproducts: {
            type: Array as PropType<PostCodeProduct[]>,
            required: true
        },
        richtext: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const { t } = useI18n();
        const postCode = ref("");
        const postCodeProducts = ref(props.postcodeproducts);
        const emptyPostCodeProduct = ref<PostCodeProduct>({
            name: "",
            productId: 0,
            partNo: ""
        });
        const selectedProduct = ref<PostCodeProduct>(emptyPostCodeProduct.value);
        const isPostCodeValid = ref(false);
        const displayInvalidPostCodeError = ref(false);
        const displayProductError = ref(false);
        const isLoading = ref(false);
        const resultMessage = ref("");
        const deliveryPossible = ref(false);
        const postCodeInput = ref<HTMLInputElement | null>(null);

        const validatePostCode = (validateErrors : boolean) => {
            isPostCodeValid.value = false;
            resultMessage.value = '';
            deliveryPossible.value = false;

            if (postCodeInput.value !== null) {
                isPostCodeValid.value = postCodeInput.value.checkValidity() && postCode.value.length > 0;
            }

            if (validateErrors || isPostCodeValid.value) {
                displayInvalidPostCodeError.value = !isPostCodeValid.value;
            }
        }

        const validateForm = () => {
            displayProductError.value = selectedProduct.value.productId === 0; 
        };

        const isDeliveryPossible = async () => {
            validatePostCode(true);
            validateForm();
            if (isPostCodeValid.value && selectedProduct.value.productId !== 0) {
                isLoading.value = true;
                try {
                    deliveryPossible.value = await DeliveryMethodApi.isDeliveryPossible(selectedProduct.value.productId, selectedProduct.value.partNo, postCode.value);
                    if (deliveryPossible.value) {
                        resultMessage.value = t("PostCodeCheck.DeliveryPossible");
                    } else {
                        resultMessage.value = t("PostCodeCheck.DeliveryNotPossible");
                    }
                } catch (e) {
                    resultMessage.value = t("PostCodeCheck.GeneralError");
                }
                isLoading.value = false;
            }
        }

        return {
            postCodeInput,
            postCode,
            postCodeProducts,
            emptyPostCodeProduct,
            selectedProduct,
            validatePostCode,
            displayProductError,
            displayInvalidPostCodeError,
            isDeliveryPossible,
            isLoading,
            resultMessage
        }
    }
});
